import Config from '../../../../AppConfig';
import styled from 'styled-components';
import { ScreenSize, FontFamily } from '../../../../enums';
import { Label, Heading } from '@mlc/web-ui-toolkit';
import * as palette from '@mlc/mlc-palette';
import AdvancedQuickSearch from '../QuickSearch/QuickSearch';

export const Card = styled.div`
	height: 135px;

	@media (max-width: ${ScreenSize.medium}) {
		border: none;
		height: auto;
		padding: 0;
	}
`;

export const Wrapper = styled.div`
	margin: 15px 0 0 0;

	span {
		margin-bottom: 0;
	}

	@media (max-width: ${ScreenSize.medium}) {
		width: 100%;
	}
`;

const searchWhiteImg = `${Config.aemImageEnv}online/resource/images/Search_white.png`;

export const SearchButton = styled.button`
	background: ${palette.mlcOrange};
	border: none;
	color: ${palette.mlcWhite};
	font-family: ${FontFamily.charlieBold};
	font-size: 18px;
	height: 44px;
	margin: 0;
	padding: 0;
	vertical-align: middle;
	width: 133px;

	&:focus,
	&:hover {
		cursor: pointer;
		text-decoration: underline;
	}

	@media (max-width: ${ScreenSize.medium}) {
		padding: 0 25px !important;
		width: auto;
	}

	@media (max-width: ${ScreenSize.xSmall}) {
		background-image: url(${searchWhiteImg});
		background-position: center center;
		background-repeat: no-repeat;
		text-indent: -9999px;
	}
`;

export const SearchIcon = styled.span`
	margin-left: 5px;
`;

export const WhiteHeader = styled(Heading)`
	color: ${palette.mlcWhite};
	margin-top: 0;
`;

export const ClientSearchHeader = styled(Label)`
	font-size: 19px;
`;

export const QuickSearch = styled(AdvancedQuickSearch)`
	margin-bottom: 20px;
	position: relative;

	@media (max-width: ${ScreenSize.medium}) {
		display: flex;
	}

	.Autosuggest {
		background-color: ${palette.mlcWhite};
		height: 44px;

		@media (max-width: ${ScreenSize.medium}) {
			flex-grow: 1;
			width: 100%;
		}

		.InputWrapper {
			height: 44px;
		}

		.autosuggest__input {
			height: 44px;
			text-overflow: ellipsis;

			@media (min-width: ${ScreenSize.medium}) {
				width: 351px;
			}

			@media (max-width: ${ScreenSize.medium}) {
				height: 44px;
			}
		}

		.autosuggest__suggestions-container--open {
			background-color: ${palette.mlcWhite};
			box-shadow: 0 1px 3px 0 ${palette.mlcBlack};
			width: 100%;
		}

		.autosuggest__suggestion {
			border-bottom: 0.3px solid #979797;
			font-size: 18px;
			padding: 10px 20px;
		}

		.autosuggest__suggestion--highlighted {
			background-color: ${palette.mlcKoala};
			color: ${palette.mlcAqua};
			text-decoration: underline;
		}

		.autosuggest__section-title {
			font-size: 13px;
			margin: 5px 0 0;
			padding: 6px 4px;
		}
	}
`;
